import { z } from "zod";

import { auditDate } from "@/schemas";

import { medRoomChecklistItem } from "../../../schemas";

export const acttMedRoomStep1Schema = z.object({
  auditDate: auditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  handHygienePosted: medRoomChecklistItem,
  firstAidKit: medRoomChecklistItem,
  doNotUseAbbreviation: medRoomChecklistItem,
  lookAlikeSoundAlike: medRoomChecklistItem,
  highAlertMed: medRoomChecklistItem,
  medRoomClean: medRoomChecklistItem,
  medSeparate: medRoomChecklistItem,
  medClosetTemp: medRoomChecklistItem,
  medClosetLight: medRoomChecklistItem,
  orderedMedLabeled: medRoomChecklistItem,
  individualMedSeparated: medRoomChecklistItem,
  medLocked: medRoomChecklistItem,
  medSupplies: medRoomChecklistItem,
});

export const acttMedRoomStep2Schema = z
  .object({
    controlledSubstanceLog: medRoomChecklistItem,
    controlledSubstanceLocked: medRoomChecklistItem,
    controlledSubstanceLockedFridge: medRoomChecklistItem,
    expiredMed: medRoomChecklistItem,
    medDestructionArea: medRoomChecklistItem,
    emergencyMed: medRoomChecklistItem,
    medPrepared: medRoomChecklistItem,
    sharpsContainer: medRoomChecklistItem,
    foodStorage: medRoomChecklistItem,
    medRefrigeratorTemperature: medRoomChecklistItem,
    cliaWaivedTest: medRoomChecklistItem,
    medCount: medRoomChecklistItem,
    waivedTestingControls: medRoomChecklistItem,
    fileMedCount: z.union([z.instanceof(File), z.null()]).optional(),
  })
  .superRefine((data, ctx) => {
    const medCountSize = data.fileMedCount?.size ?? 0;

    if (medCountSize > 2 * 1024 * 1024) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Max 2 MB",
        path: ["fileMedCount"],
      });
    }
  });

export const acttMedRoomStep3Schema = z
  .object({
    acttMedicationLog: medRoomChecklistItem,
    medOrdersMatch: medRoomChecklistItem,
    sampleMedLog: medRoomChecklistItem,
    disposalForm: medRoomChecklistItem,
    medicationErrorPhp: medRoomChecklistItem,
    medicationErrorReported: medRoomChecklistItem,
    fileDisposalForm: z.union([z.instanceof(File), z.null()]).optional(),
  })
  .superRefine((data, ctx) => {
    const disposalSize = data.fileDisposalForm?.size ?? 0;

    if (disposalSize > 2 * 1024 * 1024) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Max 2 MB",
        path: ["fileDisposalForm"],
      });
    }
  });
